const TRANSLATION = {
  buyModal: {
    afterFree: 'Після безкоштовного пробного періоду',
    btn: 'Спробуйте безкоштовно',
    freeTrial: '3-денна безкоштовна пробна версія',
    monthLabel: 'місяць',
    selectLabel: 'Виберіть план',
    title: 'План підписки',
    yearLabel: 'рік',
  },
  contact: {
    block1:
      'З питань налаштування, запитань або пропозицій зв’яжіться з нами за адресою contact@noam.tools. Ми відповімо швидко.',
    block2: 'Підтримайте нас, оцінивши нас у магазині розширень Google Apps на ★★★★★.',
    block3: 'Допоможіть іншим, поділившись цим розширенням:',
    title: "Зв'яжіться з нами",
  },
  help: {
    AquickOverviewOfNoam: 'Короткий огляд Noam',
    ChatPDF: 'Чат PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Управління обраним',
    Fixedplugin: 'Виправлений плагін',
    Focusing: 'Фокусування',
    Free: 'безкоштовно',
    FreeTrialBenefits: 'Переваги безкоштовної пробної версії',
    GoWithWikipedia: 'Використовуйте Вікіпедію',
    GoWithYouTube: 'Скористайтеся YouTube',
    HoverTranslation: 'Переклад при наведенні',
    Howtouse: 'Як використовувати',
    ImageTranslation: 'Переклад зображень',
    InstantTranslation: 'Миттєвий переклад',
    Membership: 'Членство',
    NoamHelp: 'Ноам допомагає вам перекладати та конспектувати',
    PDFparallelTranslation: 'Паралельний переклад PDF',
    ParallelTranslation: 'Паралельний переклад',
    SkipAllSteps: 'Пропустити всі кроки',
    Summary: 'Резюме',
    Translation: 'Переклад',
    TryItForFree: 'Спробуйте безкоштовно',
    Video: 'відео',
    VideoSummary: 'Резюме відео',
    VideoTranslation: 'Переклад відео',
    WebSummary: 'Веб Резюме',
    WordSelectionTranslation: 'Переклад виділення слів',
    benefits: 'На вас чекають переваги!',
    dayFree: '3-денна безкоштовна пробна версія',
    done: 'Готово',
    next: 'Далі',
    pin: 'Pin Noam для легшого доступу～～',
    planIsNotExist: 'План недоступний',
    startWiki: 'Почнемо з Wikimedia!',
    startYoutube: 'Почнемо з YouTube!',
    try: 'Спробуйте це',
    tryNow: 'Спробуйте зараз!',
  },
  home: {
    PDFTranslate: {
      desc: 'Двомовний переклад + Чат PDF',
      sub1: {
        desc: 'Двомовне читання дає змогу порівнювати оригінальний текст і переклад пліч-о-пліч, підвищуючи ефективність читання.',
        title: 'Двомовне читання',
      },
      sub2: {
        desc: 'AI аналізує та підсумовує та може відповідати на ваші запитання на основі вмісту PDF.',
        title: 'Чат PDF',
      },
      sub3: {
        desc: 'Переклад PDF-файлів за допомогою ШІ для більшої точності та ефективності.',
        title: 'Точність і ефективність',
      },
      title: 'Переклад PDF',
    },
    aiAssistant: {
      desc: 'Робимо веб-переклад розумнішим і зручнішим',
      panel1: {
        desc: 'Двомовні переклади з перехресними посиланнями допомагають вам порівняти оригінальний текст із перекладом, щоб ви могли краще зрозуміти та підвищити ефективність читання.',
        title: 'Двомовний переклад',
      },
      panel2: {
        left: {
          desc: 'Під час перегляду веб-сторінки наведіть курсор на вміст, який потрібно перекласти, щоб побачити переклад.',
          title: 'Переклад при наведенні',
        },
        right: {
          desc: 'Під час перегляду веб-сторінки виберіть текст, який потрібно перекласти, щоб переглянути переклад.',
          title: 'Переклад виділення тексту',
        },
      },
      panel3: {
        one: {
          desc: 'Перекладайте та узагальнюйте веб-сторінки та відеоконтент у будь-який час і в будь-якому місці для зручнішого досвіду!',
          title: 'Наведіть і натисніть',
        },
        three: {
          desc: 'Велика мовна модель на основі штучного інтелекту забезпечує точність і узгодженість перекладу для покращеного читання.',
          title: 'Керований ШІ',
        },
        two: {
          desc: 'Багатомовне повне покриття, двомовне читання без бар’єрів, переклад одним клацанням миші – відчуйте різницю!',
          title: 'Більш комплексний і зручний',
        },
      },
      panel4: {
        tab1: {
          desc: 'Ваш експерт з ефективності – за допомогою ChatGPT Ноам перекладає та узагальнює відеовміст YouTube, щоб заощадити ваш час!',
          key: 'відео',
          title: 'Переклад відео та резюме',
        },
        tab2: {
          desc: 'Натисніть, щоб перекласти зображення під час перегляду веб-сторінок.',
          key: 'Зображення',
          title: 'Переклад зображень',
        },
        tab3: {
          desc: 'Миттєво витягує ключову інформацію з веб-сторінок і надає резюме, підвищуючи ефективність читання.',
          key: 'Інтернет',
          title: 'Веб-перекладач і резюме',
        },
        tag1: 'простий',
        tag2: 'Ефективний',
        tag3: 'Легко зрозуміти',
      },
      title: 'ШІ помічник',
    },
    getStart: 'Почніть роботу',
    getStartedForFree: 'Почніть роботу безкоштовно',
    howItWork: {
      desc: 'Noam інтегрує моделі штучного інтелекту, щоб надати користувачам інтелектуальний досвід для перекладу й узагальнення веб-сторінок між мовами, перекладу PDF і зображень, перекладу відео та узагальнення',
      title: 'Як це працює',
    },
    lastBlock: { desc: 'Кращий переклад штучного інтелекту для плавного читання' },
    top: {
      desc: 'Noam — це безкоштовне розширення для браузера зі штучним інтелектом, яке допомагає вам перекладати та узагальнювати веб-сторінки, відео та PDF-вміст.\\n Приєднуйтеся до Noam і відчуйте магію!',
      title1: 'Одна магія',
      title2: 'Один клік',
    },
    userReviews: {
      desc: 'П’ятизіркові відгуки у веб-магазині Chrome',
      title: 'Відгуки користувачів',
    },
  },
  installTips: {
    btn: 'Спробуйте зараз',
    text: 'Установіть "Плагін для браузера Noam", щоб розблокувати більше функцій! Веб-перехресні посилання,\\n резюмування веб-відео тощо!',
  },
  locale: {
    af: 'африкаанс',
    am: 'амхарська',
    ar: 'арабська',
    as: 'асамська',
    auto: 'Автоматичне визначення',
    az: 'Азербайджанський',
    ba: 'башкирська',
    bg: 'Болгарська',
    bn: 'бенгальська',
    bo: 'тибетська',
    bs: 'боснійський',
    ca: 'каталонська',
    cs: 'чеська',
    cy: 'Валлійська',
    da: 'датська',
    de: 'Німецький',
    dsb: 'нижньолужицька',
    dv: 'Дівехі',
    el: 'грецька',
    en: 'англійська',
    es: 'Іспанська',
    et: 'Естонська',
    eu: 'Баскська',
    fa: 'перська',
    fi: 'фінська',
    fil: 'філіппінець',
    fj: 'фіджійський',
    fr: 'французька',
    frCA: 'французька (Канада)',
    ga: 'ірландський',
    gl: 'галицький',
    gom: 'Конкані',
    gu: 'Гуджараті',
    ha: 'Хауса',
    he: 'іврит',
    hi: 'Хінді',
    hr: 'Хорватська',
    hsb: 'Верхньолужицька',
    ht: 'Гаїтянська креольська',
    hu: 'угорська',
    hy: 'вірменський',
    id: 'індонезійська',
    ig: 'Ігбо',
    ikt: 'Інуіннактун',
    is: 'ісландська',
    it: 'італійська',
    iu: 'Інуктитут',
    iuLatn: 'Інуктитут (латиниця)',
    ja: 'Японський',
    ka: 'грузинський',
    kk: 'казахська',
    km: 'кхмерська',
    kmr: 'курдська (північна)',
    kn: 'каннада',
    ko: 'корейська',
    ku: 'курдська (центральна)',
    ky: 'киргизький',
    ln: 'Лінгала',
    lo: 'лаоська',
    lt: 'литовський',
    lug: 'Ганда',
    lv: 'латиська',
    lzh: 'Китайська (літературна)',
    mai: 'майтхілі',
    mg: 'малагасійська',
    mi: 'Маорі',
    mk: 'македонська',
    ml: 'малаялам',
    mnCyrl: 'монгольська (кирилиця)',
    mnMong: 'монгольська (традиційна)',
    mr: 'маратхі',
    ms: 'малайська',
    mt: 'мальтійська',
    mww: 'Хмонг До',
    my: "М'янма (бірманська)",
    nb: 'норвезька',
    ne: 'Непальська',
    nl: 'голландська',
    noSearchLang: 'Мова не підтримується',
    nso: 'Сесото са Лебоа',
    nya: 'Ньяня',
    or: 'Одія',
    otq: 'Керетаро Отомі',
    pa: 'Пенджабі',
    pl: 'польський',
    placeholder: 'Пошук',
    prs: 'Дарі',
    ps: 'пушту',
    pt: 'португальська (Бразилія)',
    ptPT: 'португальська (Португалія)',
    ro: 'румунська',
    ru: 'російська',
    run: 'Рунді',
    rw: 'Кіньяруанда',
    sd: 'Сіндхі',
    si: 'сингальська',
    sk: 'словацький',
    sl: 'словенська',
    sm: 'Самоанська',
    sn: 'Шона',
    so: 'сомалі',
    sq: 'албанець',
    srCyrl: 'сербська (кирилиця)',
    srLatn: 'сербська (латиниця)',
    st: 'сесото',
    sv: 'шведська',
    sw: 'Суахілі',
    ta: 'тамільська',
    te: 'Телугу',
    th: 'тайська',
    ti: 'Тигриня',
    tk: 'туркменський',
    tlhLatn: 'Клінгонська (латиниця)',
    tlhPiqd: 'Клінгонська (pIqaD)',
    tn: 'Сетсвана',
    to: 'тонганська',
    tr: 'турецька',
    tt: 'татарський',
    ty: 'таїтянський',
    ug: 'уйгурський',
    uk: 'українська',
    ur: 'урду',
    uz: 'узбецька (латиниця)',
    vi: "в'єтнамська",
    xh: 'Коса',
    yo: 'йоруба',
    yua: 'Юкатек майя',
    yue: 'кантонська (традиційна)',
    zh: 'китайський',
    zhHans: 'Китайська спрощена',
    zhHant: 'Китайська традиційна',
    zu: 'Зулу',
  },
  login: {
    and: 'і',
    btn: 'Увійдіть за допомогою Google',
    btn1: 'Увійдіть зараз',
    desc: 'Увійдіть, щоб розблокувати більше досвіду',
    policy: 'Політика конфіденційності',
    terms: 'Умови використання',
    tips: 'Реєструючись, я погоджуюся з',
    title: 'Ласкаво просимо до Ноама',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Слідуйте', twitter: 'Twitter' },
    legal: {
      policy: 'Політика конфіденційності',
      terms: 'Умови обслуговування',
      title: 'юридичний',
    },
    product: {
      image: 'Переклад зображень',
      pdf: 'Переклад PDF',
      title: 'Продукти',
      video: 'Переклад відео та резюме',
      web: 'Веб-переклад і резюме',
    },
    resources: { title: 'Ресурси' },
  },
  pageHeader: {
    contact: 'контакт',
    help: 'Довідка',
    logout: 'Вийти',
    logoutSucc: 'Вийшов із системи.',
    pricing: 'Ціноутворення',
    settings: 'Налаштування',
    signUp: 'Увійти',
  },
  pdf: {
    autoDetect: 'Автоматичне визначення',
    cancelBtn: 'Скасувати',
    cancelUpload: 'Скасувати',
    chatPdf: {
      Search: 'Пошук',
      cancel: 'Скасувати',
      chatTitle: 'Ласкаво просимо до Ноама! Ось короткий опис вашого PDF-файлу:',
      clear: 'ясно',
      clearContent: 'Це почне нову розмову. Поточна бесіда не буде збережена. Ви впевнені?',
      clearDialogTitle: 'Будь ласка, підтвердьте',
      clearSucc: 'Очищено',
      copy: 'Копія',
      copySucc: 'Скопійовано',
      delete: 'Видалити',
      deleteCancel: 'Скасувати',
      deleteContent: 'Цей PDF неможливо відновити після видалення. Ви впевнені?',
      deleteOk: 'Видалити',
      deleteSuccess: 'Видалено',
      deleteTitle: 'Підтвердьте видалення',
      expand: 'Згорнути',
      historyTitle: 'історія',
      listError:
        'Не вдалося завантажити список для читання. Спробуйте пізніше або зверніться до служби підтримки.',
      loading: 'Завантаження...',
      noDataDesc: 'Історії ще немає.',
      noMore: 'Більше немає вмісту.',
      placeholder: 'Запитайте будь-що про цей PDF-файл',
      summaryTitle: 'Вас можуть зацікавити такі питання:',
    },
    collectionEmpty: 'Ваша колекція порожня.',
    collectionTab: 'Примітки',
    dataLoading: 'Завантаження...',
    dialogContent: 'Ви впевнені, що хочете це видалити?',
    dialogTitle: 'Будь ласка, підтвердьте',
    download: {
      both: 'Двомовний',
      btn: 'зберегти',
      cancel:
        'Якщо закрити це вікно, завантаження PDF буде скасовано. Ви впевнені, що бажаєте скасувати?',
      desc: 'Зберегти на пристрій: завантажує переклади як зображення; Зберегти та надрукувати: завантажує переклади в оригінальному форматі з підтримкою копіювання.',
      download: 'Завантажити',
      downloadMsg1: 'Хід перекладу PDF:',
      downloadMsg2: 'Приблизний час, що залишився:',
      downloadSucc: 'PDF готовий! Натисніть, щоб зберегти.',
      downloadTip: 'Завантаження PDF. Не закривайте це вікно, щоб уникнути помилок завантаження.',
      error: 'Не вдалося зберегти. Натомість спробуйте надрукувати.',
      fileName: "Ім'я файлу:",
      fileType: 'Тип файлу:',
      loading: 'Збереження...',
      loading2: 'Завантаження...',
      minute: 'хвилин...',
      msg1: 'Деякі переклади в цьому документі довші за оригінальний текст і можуть накладатися на завантажений файл. Рекомендуємо прочитати на сайті.',
      msg2: '1. Переклад ще не завершено. Будь ласка, завантажте після завершення перекладу.',
      msg3: '2. Деякі переклади надто довгі. Читайте на веб-сторінці, щоб уникнути накладання тексту.',
      msg4: 'Виконуються завдання з перекладу. Будь ласка, спробуйте ще раз після їх завершення.',
      progress:
        'Переклад PDF. Перебіг: {{progress}}, приблизний час, що залишився: {{minutes}} хвилин...',
      save: 'Зберегти на пристрій',
      savePrint: 'Зберегти та роздрукувати',
      success: 'Завантажено',
      trans: 'Тільки переклад',
      transContinue: 'Продовжити переклад',
    },
    downloadBtn: 'Завантажити',
    dragTipModal: {
      black: 'простір',
      leftKey: 'ліва кнопка',
      ok: 'Зрозуміло',
      press: 'Прес',
      tips: 'для перетягування та перегляду.',
    },
    entry: 'PDF-файли',
    fileErrMsg: 'Не вдалося прочитати файл. Спробуйте пізніше або зверніться до служби підтримки.',
    fileMsg: 'Поточний розмір файлу:',
    fileMsg2: 'Будь ласка, завантажте файл розміром менше 300 Мб.',
    freeBannerBtn: 'Оновлення',
    freeBannerTips: 'Досягнуто ліміту безкоштовних перекладів PDF',
    guide: {
      placeholder: 'Вставте посилання на PDF тут',
      start: 'Розпочати переклад',
      text1: 'Двомовне читання',
      text2:
        'Читайте двомовно, щоб порівняти оригінальний текст і переклад пліч-о-пліч, підвищуючи свою ефективність.',
      text3: 'Спілкуйтеся зі своїм PDF-файлом',
      text4:
        'Аналіз та узагальнення за допомогою AI. Ставте запитання про свій PDF-файл і миттєво отримуйте відповіді.',
      text5: 'Точний і ефективний',
      text6: 'Переклад PDF-файлів за допомогою ШІ для більшої точності та ефективності.',
      title1: 'Двомовний переклад',
      title2: 'Спілкуйтеся зі своїм PDF-файлом',
      toast: 'Введіть дійсне онлайн-посилання на PDF-файл із розширенням .pdf',
    },
    hasTransTask: 'Виконується завдання перекладу. Будь ласка, зачекайте.',
    hoverTrans: 'Абзаци з наведенням курсора на переклад',
    initial: 'Перекласти PDF',
    installText: 'Ваше універсальне рішення для щоденних перекладів.',
    installText2: 'Спочатку встановіть розширення',
    installTips:
      'Установіть розширення для ще більшої кількості перекладів PDF і плавніших перекладів веб-сайтів:',
    kw: 'скоба',
    link: 'посилання',
    listError:
      'Не вдалося завантажити файли PDF. Спробуйте пізніше або зверніться до служби підтримки.',
    memoTotalCount: 'Всього 1 шт',
    new: 'новий файл',
    noId: 'Ідентифікатор файлу не знайдено.',
    notPdf: 'Лише файли PDF.',
    okBtn: 'Видалити',
    okBtn2: 'Зрозуміло',
    original: 'Оригінал',
    parallel: 'Паралельний',
    parseErrDialogContent:
      'Це PDF-посилання неможливо перекласти безпосередньо. Завантажте PDF-файл і завантажте його для перекладу.',
    parseErrTips: 'Не вдалося проаналізувати файл',
    parseFileToast:
      'Не вдалося проаналізувати файл. Спробуйте пізніше або зверніться до служби підтримки.',
    pdfLoading: 'Розбір...',
    searchPlaceholder: 'Пошук',
    selectTrans: 'Виберіть Текст для перекладу',
    shareBtn: 'Поділіться',
    shareBtnText1: 'Створити посилання для спільного доступу',
    shareBtnText2: 'Оновити спільний вміст',
    shareModal: {
      cancel: 'Скасувати',
      copy: 'Копія',
      copySucc: 'Посилання скопійовано',
      custom: 'Налаштувати:',
      errMsg:
        'Вибраний вміст ще не повністю перекладено. Будь ласка, перекладіть, перш ніж ділитися.',
      gen: 'Поділіться',
      modify: 'Редагувати',
      notSupport: 'Ця мова наразі не підтримується.',
      page: 'сторінки',
      pageNuErr: 'Введіть дійсний номер сторінки.',
      range: 'Сфера застосування:',
      remain: 'залишилося',
      remain1: 'Загальний приблизний час:',
      search: 'Пошук',
      settings: 'Налаштування спільного доступу:',
      shareSetting: 'Налаштування спільного доступу',
      shareText: 'Поділіться',
      shareTips: 'Поділіться посиланням на переклад PDF із друзями:',
      sourceLang: 'Від:',
      target: 'до:',
      text1: 'Налаштування спільного доступу',
      text2: 'Створити посилання для спільного доступу',
      totalPage: 'Всього 1 сторінка',
      trans: 'Перекласти',
      translateTips:
        'Порада: якщо переклад займає деякий час, ви можете закрити це вікно та поділитися пізніше.',
      translating: 'Переклад PDF...',
      update: 'Оновити посилання для спільного доступу',
    },
    shareMsg1: 'Згенеровано посилання для спільного доступу.',
    shareMsg2: 'Спільний вміст оновлено.',
    shareMsg3:
      'Не вдалося створити посилання для спільного доступу. Спробуйте пізніше або зверніться до служби підтримки.',
    shareMsg4:
      'Не вдалося оновити спільний вміст. Спробуйте пізніше або зверніться до служби підтримки.',
    shareTips: 'Ваш переклад PDF готовий! Поділіться з друзями.',
    start: 'Почніть безкоштовну пробну версію',
    thumbnail: 'Зміст',
    toast1: 'Завантаження PDF. Спробуйте пізніше.',
    toast2: 'Вміст PDF-файлу завеликий. Діалог наразі не підтримується.',
    toast3: 'Завантаження. Спробуйте ще раз після завершення завантаження.',
    toolbar: { Adjust: 'Налаштувати', autoFit: 'Автопідбір' },
    trans: 'Переклад',
    transSucc: 'Переклад вдався!',
    unLoginToast: 'Увійдіть, щоб скористатися цією функцією.',
    uploadBtn: 'Завантажити',
    uploadErr: 'Помилка завантаження файлу. Спробуйте пізніше або зверніться до служби підтримки.',
    uploadMsg1: 'Перетягніть файл сюди.',
    uploadMsg2: 'Підтримувані типи файлів: PDF |  Максимальний розмір файлу: 100 МБ',
    uploadMsg3: 'Натисніть, щоб вибрати або перетягнути файли сюди.',
    uploading: 'Завантаження',
    uploadingMsg: 'Завантаження. Будь ласка, зачекайте.',
    uploadingMsg1: 'Файл завантажується. Спробуйте пізніше.',
    uploadingMsg2: 'Файл зараз конвертується. Спробуйте пізніше.',
    uploadingMsg3:
      'Помилка запиту на хід перетворення. Спробуйте пізніше або зверніться до служби підтримки.',
    uploadingMsg4:
      'Ноам не може отримати доступ до локальних файлів. Будь ласка, вручну завантажте PDF для перекладу.',
    uploadingMsg5:
      'Не вдалося отримати URL-адресу файлу. Спробуйте пізніше або зверніться до служби підтримки.',
    video: 'відео',
    vipBannerBtn: 'Оновлення',
    vipBannerTips: 'Ви досягли ліміту перекладів PDF за цей місяць.',
    webTrans: 'Повне перехресне посилання',
  },
  pricing: {
    FAQ: 'FAQ',
    FQAObj: {
      a1: 'Так, Noam пропонує безкоштовний план, яким можна скористатися одразу.',
      a2: 'Ми пропонуємо три плани членства: Pro, Pro+ і Enterprise. Ви можете вибрати щомісячну або щорічну оплату. Річна виставка рахунків дає значну економію.',
      a3: 'Усі функції доступні в обох планах. Основна відмінність полягає у вартості: річна підписка в цілому коштує дешевше. Рахунки за місячну підписку виставляються щомісяця, а за річні плани — раз на рік.',
      a4: 'Ви можете будь-коли скасувати підписку в налаштуваннях облікового запису.',
      q1: 'Чи є безкоштовний план?',
      q2: 'Які тарифні плани та варіанти оплати доступні?',
      q3: 'Яка різниця між місячною підпискою та річною?',
      q4: 'Як скасувати підписку?',
    },
    around: 'Навколо',
    billedMonthly: 'Рахунок виставляється щомісяця',
    billedYearly: 'Рахунок виставляється щорічно',
    day: 'день',
    desc: 'Порівняйте плани та виберіть найкращий',
    detailedCompare: 'Порівняти плани',
    discount: 'Знижка 20%.',
    enterprise: {
      benefit1: 'Пріоритетна підтримка клієнтів',
      benefit2: 'Кілька користувачів',
      benefit3: 'Індивідуальні рішення',
      benefit5: 'Спеціальний менеджер з роботи з клієнтами',
      btn: "Зв'яжіться з нами",
      recommendText: 'Спеціальні плани（≥3人）',
      talkToUs: "Зв'яжіться з нами",
    },
    free: {
      benefit1: 'Миттєвий переклад 100 раз/день',
      benefit2: 'Переклад веб-сайту та резюме',
      benefit3: '30 перекладів зображень',
      benefit4: 'Переклад відео та резюме',
      benefit5: '10 перекладів PDF',
      benefit6: '5000 жетонів',
      btn: 'Спробуйте безкоштовно',
      recommendText: 'Безкоштовна пробна версія',
    },
    imageTranslation: 'Переклад зображень',
    month: 'місяць',
    monthly: 'Щомісяця',
    pageTitle: 'Ціноутворення',
    pdf: {
      chat: 'PDF Chat Queries',
      maxPage: 'Макс. Сторінок на PDF',
      translation: 'Переклад PDF',
    },
    preMonth: 'на місяць',
    pro: {
      benefit1: 'Пріоритетна підтримка клієнтів',
      benefit2: '1 000 000 токенів на місяць',
      benefit3: 'Переклад веб-сайту та резюме',
      benefit4: '200 перекладів зображень',
      benefit5: 'Переклад відео та резюме',
      benefit6: '200 перекладів PDF',
      btn: 'Почніть роботу',
      recommendText: 'Найпопулярніший',
    },
    proPlus: {
      benefit1: 'Пріоритетна підтримка клієнтів',
      benefit2: '3 000 000 токенів на місяць',
      benefit3: 'Переклад веб-сайту та резюме',
      benefit4: '500 перекладів зображень',
      benefit5: 'Переклад відео та резюме',
      benefit6: '500 перекладів PDF',
      recommendText: 'Найкраще значення',
    },
    video: { summary: 'Резюме відео', translation: 'Переклад відео' },
    web: {
      contrastiveTranslation: 'Двомовний переклад',
      dictionaryTranslation: 'Вибір перекладу',
      hoverTranslation: 'Переклад при наведенні',
      instantTranslation: 'Миттєвий переклад',
      summary: 'Резюме веб-сторінки',
    },
    yearly: 'щорічно',
  },
  privacy: {
    block1:
      'Noam («Ноам», «ми», «наш» або «нас») поважає вашу конфіденційність і зобов’язується захищати будь-яку інформацію, яку ми отримуємо від вас або про вас. Ця Політика конфіденційності описує нашу практику щодо збору або використання особистої інформації в результаті використання вами нашого веб-сайту, програм і служб (разом «Сервіси»). Ця Політика конфіденційності не поширюється на вміст, який ми обробляємо від імені клієнтів наших бізнес-продуктів, таких як наш API. Використання цих даних регулюється нашою клієнтською угодою, яка охоплює доступ до цих продуктів і їх використання.',
    block10:
      'Ми вживаємо комерційно обґрунтовані технічні, адміністративні та організаційні заходи для захисту особистої інформації в режимі онлайн і офлайн від втрати, неправильного використання та несанкціонованого доступу, розголошення, зміни чи ворожих дій. Однак жодна передача через Інтернет чи електронну пошту не може гарантувати повну безпеку чи точність. Зокрема, електронні листи, надіслані нам або від нас, можуть бути небезпечними. Тому вам слід бути особливо обережними, вирішуючи, яку інформацію надсилати нам через службу чи електронну пошту. Крім того, ми не несемо відповідальності за будь-які перешкоди налаштуванням конфіденційності чи заходам безпеки в службі або на сторонніх веб-сайтах. Ми зберігатимемо вашу особисту інформацію стільки часу, скільки це буде необхідно для надання вам послуг або для інших законних бізнес-цілей, таких як вирішення спорів, забезпечення безпеки чи дотримання наших юридичних зобов’язань. Тривалість часу, протягом якого ми зберігаємо особисту інформацію, залежатиме від багатьох факторів, таких як обсяг, характер, конфіденційність інформації, потенційні ризики несанкціонованого використання або розкриття, цілі, для яких ми обробляємо інформацію, та інші юридично обов’язкові міркування.',
    block11:
      'Час від часу ми можемо оновлювати цю Політику конфіденційності. Коли ми це зробимо, ми опублікуємо оновлену версію на цій сторінці, якщо інше не вимагається чинним законодавством.',
    block12:
      'Якщо у вас виникли запитання чи сумніви щодо цієї Політики конфіденційності без відповіді, зверніться до нашої служби підтримки клієнтів. Електронна пошта:',
    block2: 'Ми збираємо наступну особисту інформацію («Особиста інформація»), яка стосується вас:',
    block3:
      'Інформація, надана вами. Коли ви створюєте обліковий запис, щоб користуватися нашими послугами або спілкуватися з нами, ми збираємо особисту інформацію таким чином:',
    block4:
      'Персональна інформація, автоматично отримана під час використання вами послуг: коли ви отримуєте доступ до послуг, використовуєте або взаємодієте з ними, ми отримуємо таку інформацію про ваш доступ, використання або взаємодію («Технічна інформація»):',
    block5: 'Ми можемо використовувати особисту інформацію для таких цілей:',
    block6:
      'Коротка або деідентифікована інформація: ми можемо збирати або деідентифікувати особисту інформацію, щоб запобігти її повторному використанню з метою ідентифікації та використовувати таку інформацію для аналізу ефективності наших послуг, покращення та додавання функцій до наших послуг, проведення досліджень тощо для подібних цілей. . Крім того, ми можемо аналізувати загальну поведінку та характеристики користувачів наших послуг і ділитися зведеною інформацією з третіми сторонами, публікувати таку зведену інформацію або робити її загальнодоступною. Ми можемо збирати сукупну інформацію за допомогою служб, файлів cookie та іншими засобами, описаними в цій Політиці конфіденційності. Ми зберігатимемо та використовуватимемо деідентифіковану інформацію в анонімній або деідентифікованій формі, і ми не намагатимемося повторно ідентифікувати таку інформацію, якщо цього не вимагає закон.',
    block7:
      'У деяких випадках ми можемо надати вашу особисту інформацію третім особам без додаткового повідомлення, якщо цього не вимагає закон:',
    block8:
      'Залежно від вашого географічного розташування особи в Європейській економічній зоні, Сполученому Королівстві та в усьому світі можуть мати певні законні права щодо своєї особистої інформації. Наприклад, ви можете мати право:',
    block9:
      'Служба може містити посилання на інші веб-сайти, якими не керує та не контролює Noam, включно зі службами соціальних мереж («Сторонні веб-сайти»). Інформація, яку ви надаєте стороннім веб-сайтам, регулюватиметься конкретною політикою конфіденційності й умовами обслуговування веб-сайтів третіх сторін, а не цією Політикою конфіденційності. Ми надаємо ці посилання для зручності та не означаємо нашу підтримку чи перегляд цих веб-сайтів. Будь ласка, зв’яжіться безпосередньо зі сторонніми веб-сайтами, щоб отримати інформацію про їх політику конфіденційності та умови.',
    subBlock1:
      'Інформація про обліковий запис: коли ви створюєте обліковий запис на нашій платформі, ми збираємо інформацію, пов’язану з вашим обліковим записом, зокрема ваше ім’я, контактну інформацію, облікові дані облікового запису, дані платіжної картки та історію транзакцій («Інформація про обліковий запис»).',
    subBlock10: 'Надання, управління, обслуговування та/або аналіз послуг;',
    subBlock11: 'Спілкування з вами;',
    subBlock12: 'Розробка нових продуктів і послуг;',
    subBlock13:
      'Запобігання шахрайству, злочинній діяльності або зловживанню нашими послугами та захист безпеки наших ІТ-систем, архітектури та мереж;',
    subBlock14: 'Здійснення ділових переказів;',
    subBlock15:
      'Дотримання юридичних зобов’язань і судових розглядів, захист наших прав, конфіденційності, безпеки чи власності, а також прав наших афілійованих осіб, вас чи інших третіх сторін.',
    subBlock16:
      'Постачальники та постачальники послуг: щоб допомогти нам задовольнити оперативні потреби бізнесу та виконати певні послуги та функції, ми можемо надавати особисту інформацію постачальникам і постачальникам послуг, включаючи постачальників послуг хостингу, постачальників хмарних послуг та інших постачальників послуг інформаційних технологій, програмного забезпечення електронної пошти. , а також постачальники послуг веб-аналітики тощо. Ці партнери отримають доступ, оброблятимуть або зберігатимуть особисту інформацію лише за нашим вказівкою під час виконання своїх обов’язків для нас.',
    subBlock17:
      'Передача бізнесу: якщо ми беремо участь у стратегічних трансакціях, реорганізаціях, банкрутствах, поглинаннях через банкрутство або передаємо послуги іншому постачальнику (разом «Трансакції»), ваша особиста та інша інформація може бути передана партнерам угод та іншим сторонам, які допомагають у трансакціях. під час належної перевірки та передано в рамках Трансакцій разом з іншими активами правонаступнику або афілійованій компанії.',
    subBlock18:
      'Юридичні вимоги: ми можемо надавати вашу особисту інформацію державним органам, колегам галузі чи іншим третім сторонам, включаючи інформацію про вашу взаємодію з нашими службами, (1) якщо цього вимагає закон або якщо ми вважаємо, що така дія необхідна для виконання юридичних зобов’язань; (2) для захисту та захисту наших прав або власності; (3) якщо ми в односторонньому порядку визначимо, що є порушення наших умов, політики або законів; (4) для виявлення або запобігання шахрайству чи іншим незаконним діям; (5) для захисту наших продуктів, співробітників або користувачів, а також громадської безпеки, безпеки та цілісності; або (vi) для захисту від юридичної відповідальності.',
    subBlock19: 'Доступ до вашої особистої інформації та інформації про те, як вона обробляється.',
    subBlock2:
      'Вміст користувача: коли ви користуєтеся нашими послугами, ми збираємо особисту інформацію з ваших даних, завантажених файлів або наданих нам відгуків («Вміст»).',
    subBlock20: 'Вимагайте видалення вашої особистої інформації з наших записів.',
    subBlock21: 'Виправте або оновіть свою особисту інформацію.',
    subBlock22: 'Передати свою особисту інформацію третій стороні (переносність даних).',
    subBlock23: 'Обмежте спосіб обробки вашої особистої інформації.',
    subBlock24:
      'Відкликайте свою згоду — якщо ми покладаємося на згоду як правову основу для обробки, ви можете відкликати свою згоду в будь-який час.',
    subBlock25: 'Заперечувати проти того, як ми обробляємо вашу особисту інформацію.',
    subBlock26: 'Покращення наших послуг і проведення досліджень;',
    subBlock3:
      'Інформація для спілкування: якщо ви надсилаєте нам повідомлення, ми збиратимемо ваше ім’я, контактну інформацію та вміст ваших повідомлень («Інформація для спілкування»).',
    subBlock4:
      'Інформація про соціальні мережі: у нас є сторінки на веб-сайтах соціальних мереж, таких як Instagram, Facebook, Medium, Twitter, YouTube і LinkedIn. Коли ви взаємодієте з нашими сторінками в соціальних мережах, ми збираємо особисту інформацію, яку ви надаєте нам, наприклад, ваші контактні дані («Соціальна інформація»). Крім того, компанії, які розміщують наші сторінки в соціальних мережах, можуть надавати нам узагальнену інформацію та аналіз нашої діяльності в соціальних мережах.',
    subBlock5:
      'Дані журналу: інформація, яку автоматично надсилає ваш браузер під час використання наших послуг. Дані журналу включають вашу адресу Інтернет-протоколу (IP), тип і налаштування браузера, дату й час ваших запитів і те, як ви взаємодієте з нашим веб-сайтом.',
    subBlock6:
      'Дані про використання: ми можемо автоматично збирати інформацію про використання вами служби, як-от типи вмісту, який ви переглядаєте або з яким взаємодієте, функції, які ви використовуєте, дії, які ви виконуєте, а також ваш часовий пояс, країну, дату та час доступ, агент користувача та версія, тип комп’ютера або мобільного пристрою та підключення до комп’ютера.',
    subBlock7:
      'Інформація про пристрій: це включає назву пристрою, операційну систему, ідентифікатор пристрою та браузер, який ви використовуєте. Зібрана інформація може залежати від типу пристрою, який ви використовуєте, і його налаштувань.',
    subBlock8:
      'Файли cookie: ми використовуємо файли cookie, щоб працювати з нашими послугами та керувати ними, а також покращувати ваш досвід. "Cookie" - це інформація, яку веб-сайт, який ви відвідуєте, надсилає у ваш браузер. Ви можете налаштувати свій браузер таким чином, щоб він приймав усі файли cookie, відхиляв усі файли cookie або сповіщав вас, коли надається файл cookie, щоб ви могли щоразу вирішувати, чи приймати його. Однак відмова від файлів cookie може перешкодити вам використовувати або негативно вплинути на відображення чи функціональність певних областей або функцій веб-сайту. Для отримання додаткової інформації про файли cookie відвідайте сторінку All About Cookies.',
    subBlock9:
      'Аналітика: ми можемо використовувати різноманітні онлайн-аналітичні продукти, які використовують файли cookie, щоб допомогти нам проаналізувати, як користувачі використовують наші послуги, і покращити ваш досвід під час використання служб.',
    subTitle1: 'Особиста інформація, яку ми збираємо',
    subTitle2: 'Як ми використовуємо особисту інформацію',
    subTitle3: 'Розкриття особистої інформації',
    subTitle4: 'Ваші права',
    subTitle5: 'Посилання на інші веб-сайти',
    subTitle6: 'Безпека та збереження інформації',
    subTitle7: 'Зміна Політики конфіденційності',
    subTitle8: "Як з нами зв'язатися",
    title: 'Політика конфіденційності',
    updateTime: 'Оновлено: 15 березня 2024 р',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Прийняти всі',
    text: 'Щоб покращити ваш досвід, ми використовуємо файли cookie для персоналізації вмісту та послуг.',
    title: 'Цей сайт використовує файли cookie',
  },
  slogen: 'Найпростіший AI-помічник',
  stripe: {
    contact: 'З будь-якими запитаннями звертайтеся до нас за адресою contact@noam.tools!',
    fail: {
      btn: 'Повторіть спробу',
      text1: 'Нам не вдалося обробити ваш платіж.',
      text2: 'Перевірте підключення та повторіть спробу.',
      title: 'Платіж не вдалося',
    },
    succ: {
      btn: 'Йдемо',
      text1: 'Ласкаво просимо до Ноама,',
      text2: 'давайте почнемо!',
      title: 'Вітаю',
    },
  },
  terms: {
    block1: 'Дякуємо за використання Noam!',
    block10:
      '(a) Комісії та виставлення рахунків. Ви сплачуєте всі збори («Збори») відповідно до цін і умов на відповідній сторінці цін або згідно з письмовою домовленістю між нами. Ми залишаємо за собою право виправляти помилки в ціноутворенні або помилки, навіть якщо ми виставили рахунки або отримали платіж. Ви надасте повну та точну платіжну інформацію, включаючи дійсний та авторизований спосіб оплати. Ми будемо періодично стягувати плату з вашого методу оплати, як узгоджено, але ми можемо обґрунтовано змінити дату виставлення рахунку. Ви дозволяєте Noam, його афілійованим особам і стороннім обробникам платежів стягувати плату за ваш метод оплати. Якщо ваш платіж не здійснено, ми надішлемо вам письмове повідомлення та можемо призупинити доступ до Сервісу до отримання платежу. Якщо інше не зазначено в цій угоді, платежі не повертаються.',
    block11:
      '(b) Податки. Якщо не зазначено інше, комісія не включає будь-які федеральні, державні, місцеві та іноземні податки, збори та подібні нарахування («Податки»). Ви несете відповідальність за сплату всіх податків, пов’язаних із вашими покупками, за винятком податків, які базуються на нашому чистому доході, за який ми виставимо вам рахунок. Ви погоджуєтеся негайно сплачувати такі податки, надаєте нам юридично дійсні заяви про конфіденційність і отримуєте необхідні дозволи на обробку таких даних, і ви гарантуєте нам, що обробляєте такі дані відповідно до чинного законодавства.',
    block12:
      '(c) Зміни ціни. Ми можемо змінити наші ціни, повідомивши вас через ваш обліковий запис і/або на нашому веб-сайті. Підвищення цін почне діяти відразу після публікації. Будь-які зміни цін застосовуватимуться до Комісії для вашого облікового запису після дати набуття чинності змін.',
    block13:
      '(d) Спори та прострочені платежі. Якщо ви бажаєте оскаржити будь-які комісії чи податки, зв’яжіться з contact@noam.tools протягом тридцяти (30) днів із дати виставлення рахунку.',
    block14:
      '(e) Безкоштовне використання. Ви не можете створити кілька облікових записів, щоб отримати безкоштовні кредити. Якщо ми визначимо, що ви не сумлінно використовуєте безкоштовні кредити, ми можемо стягувати з вас стандартні збори або припинити надання доступу до Сервісу.',
    block15:
      '(a) Конфіденційність. Ви можете мати доступ до конфіденційної інформації Noam. Ви можете використовувати конфіденційну інформацію лише в межах, дозволених цими умовами, з метою використання Сервісу. Ви не маєте права розголошувати конфіденційну інформацію будь-якій третій стороні, і ви будете захищати конфіденційну інформацію у спосіб, не менш надійний, ніж ви захищаєте свою власну подібну конфіденційну інформацію, принаймні з розумною обережністю. Конфіденційна інформація — це закрита інформація, визначена Noam як конфіденційна або з якою слід розумно розглядатися як конфіденційна за даних обставин, включаючи програмне забезпечення, специфікації та іншу закриту бізнес-інформацію. Конфіденційна інформація не включає інформацію, яка: (1) стає загальнодоступною без вашої вини; (2) ви мали у своєму розпорядженні без будь-яких зобов’язань щодо конфіденційності до отримання за цими умовами; (3) законно розкрито вам третьою стороною без будь-яких зобов’язань щодо конфіденційності; або (4) самостійно розроблено вами без використання конфіденційної інформації. Ви можете розкривати конфіденційну інформацію, якщо це вимагається законом, судом чи іншим державним розпорядженням, але ви повинні надати Ноаму попереднє письмове повідомлення в розумний спосіб і, наскільки це можливо, докласти розумних зусиль, щоб обмежити обсяг розкриття, зокрема допомогти нам у запереченні запитів на розкриття інформації.',
    block16:
      '(b) Безпека. Ви повинні вжити розумних і відповідних заходів, щоб захистити свій доступ до Послуги та використання нею. Якщо ви виявите будь-які вразливості або порушення, пов’язані з використанням вами Сервісу, ви повинні негайно зв’язатися з Noam і надати детальну інформацію про вразливість або порушення.',
    block17:
      '((c) Обробка персональних даних. Якщо ви використовуєте Сервіс для обробки персональних даних, ви повинні надати юридично достатні заяви про конфіденційність і отримати необхідні згоди на обробку таких даних, і ви гарантуєте нам, що обробляєте такі дані відповідно до чинного законодавства .',
    block18:
      '(a) Припинення; Підвіска. Ці умови набудуть чинності з моменту першого використання Сервісу та залишатимуться в силі до припинення дії. Ви можете припинити дію цих умов у будь-який час з будь-якої причини, припинивши використання Сервісу та Вмісту. Ми можемо припинити дію цих умов із попереднім повідомленням з будь-якої причини. Ми можемо негайно припинити дію цих умов, повідомивши вас, якщо ви суттєво порушуєте Розділ 2 (Вимоги до використання), Розділ 5 (Конфіденційність, безпека та захист даних), Розділ 8 (Вирішення суперечок) або Розділ 9 (Загальні умови), або якщо наші зміни відносин із будь-яким стороннім постачальником технологій поза нашим контролем або для дотримання закону чи державних запитів. Ми можемо призупинити ваш доступ до Сервісу, якщо ви не дотримуєтеся цих умов, або якщо використання вами створює загрозу безпеці для нас або будь-якої третьої сторони, або якщо ми підозрюємо, що використання вами є шахрайським або може притягнути нас або будь-яку третю сторону до відповідальності .',
    block19:
      '(b) Наслідки розірвання. Після припинення дії ви припините користуватися Сервісом і негайно повернете або знищите будь-яку конфіденційну інформацію згідно з нашими вказівками. Положення цих умов, які за своїм характером мають залишатися в силі після припинення або закінчення терміну дії, включаючи, але не обмежуючись, Розділи 3 і 5-9, залишаються в силі.',
    block2:
      'Ці Умови використання стосуються використання вами послуг Noam, включаючи наші програмні інтерфейси, програмне забезпечення, інструменти, служби розробників, дані, документацію та веб-сайт (разом іменовані «Сервіси»). Користуючись нашими Сервісами, ви погоджуєтеся дотримуватися цих умов. Наша Політика конфіденційності пояснює, як ми збираємо та використовуємо особисту інформацію.',
    block20:
      '(a) Відшкодування. Ви зобов’язуєтеся захищати, відшкодовувати збитки та звільняти нас, наших афілійованих осіб і наш персонал від будь-яких претензій, збитків і витрат (включаючи гонорари адвокатів), що виникають унаслідок або пов’язані з використанням вами Сервісу, включаючи ваш Вміст, ваші використання продуктів або послуг, пов’язаних із Сервісом, а також порушення вами цих умов або чинного законодавства.',
    block21:
      '(b) Відмова від відповідальності. Сервіс надається «як є». Наскільки це дозволено законодавством, ми та наші філії та ліцензіари не робимо жодних заяв або гарантій будь-якого роду щодо Сервісу та не надаємо жодних гарантій, включаючи, але не обмежуючись гарантіями комерційної придатності, придатності для певної мети, задовільної якості, відсутності порушень , і тихе задоволення, а також будь-які гарантії, що виникають у зв’язку з угодою чи використанням торгівлі. Ми не гарантуємо, що Служба буде безперебійною, точною чи безпомилковою, або що будь-який Вміст буде безпечним, не втраченим чи не зміненим.',
    block22:
      '(c) Обмеження відповідальності. Ні ми, ні наші філії, ні наші ліцензіари не несемо відповідальності за будь-які непрямі, випадкові, спеціальні, непрямі або штрафні збитки, включаючи втрату прибутку, втрату репутації, втрату використання, втрату даних або інші нематеріальні збитки, навіть якщо ми були попереджені про можливість таких пошкоджень. Згідно з цими умовами, наша загальна відповідальність не перевищуватиме Комісії, яку ви сплатили за Службу за дванадцять (12) місяців до претензії, або сто доларів США ($100), залежно від того, що більше. Обмеження в цьому розділі застосовуються в максимальному ступені, дозволеному чинним законодавством.',
    block23:
      'Умови та використання вами Послуг регулюються законодавством Сполучених Штатів, за винятком норм колізійного права США. Використання вами Програми також може регулюватися іншими місцевими, державними, національними чи міжнародними законами. Будь-який судовий позов або провадження, пов’язані з цими Умовами, розглядатимуться виключно в судах Сполучених Штатів, і ви погоджуєтеся підпорядковуватися персональній юрисдикції таких судів.',
    block24:
      '(a) Відносини Сторін. Ноам і ви є незалежними підрядниками, і жодна зі сторін не має повноважень представляти чи зобов’язувати іншу сторону чи брати на себе зобов’язання за іншу сторону без попередньої письмової згоди іншої сторони.',
    block25:
      '(b) Використання торгової марки. Ви не маєте права використовувати ім’я, логотипи або торгові марки Noam або будь-яких її філій без нашої попередньої письмової згоди.',
    block26:
      'Якщо будь-яке положення цих умов буде визнано недійсним, незаконним або таким, що не підлягає виконанню, решта положень залишатимуться в повній силі.',
    block3:
      'Якщо вам менше 18 років, ви повинні отримати дозвіл від своїх батьків або законних опікунів на використання Сервісу. Якщо ви використовуєте Службу від імені іншої фізичної чи юридичної особи, ви повинні мати дозвіл прийняти ці умови від їхнього імені. Ви повинні надати точну та повну інформацію, щоб зареєструвати обліковий запис. Ви не маєте права надавати свої облікові дані доступу або обліковий запис нікому за межами вашої організації, і ви несете відповідальність за всі дії, що виконуються з використанням ваших облікових даних.',
    block4:
      '(a) Використання Сервісу. Ви можете отримати доступ до Сервісу відповідно до цих умов, і ми надаємо вам невиключне право використовувати Сервіс. Користуючись Сервісом, ви зобов’язуєтеся дотримуватися цих умов і всіх чинних законів. Ми та наші філії володіємо всіма правами, титулами та інтересами в Сервісі.',
    block5:
      "(b) Зворотній зв'язок. Ми вітаємо відгуки, коментарі, ідеї, пропозиції та вдосконалення. Якщо ви надаєте такий вміст, ми можемо використовувати його без будь-яких обмежень і без компенсації.",
    block6:
      '(c) Обмеження. Ви не маєте права: (1) використовувати Службу у спосіб, який порушує, привласнює або порушує будь-які права інших осіб; (2) здійснювати зворотне проектування, декомпілювати, розбирати, перекладати або іншим чином намагатися виявити вихідний код або базові компоненти моделей, алгоритмів і систем Сервісу (якщо такі обмеження не заборонені чинним законодавством); (3) використовувати результати Служби для розробки моделей, що конкурують з Noam; (4) отримувати дані або вихідні дані зі Сервісу за допомогою будь-яких автоматизованих методів або методів програмування, якщо це не дозволено через API, зокрема копіювання, збір веб-сторінок або вилучення веб-даних; (5) представляти результати Служби як штучно створені, хоча це не так, або іншим чином порушувати нашу політику використання; (6) купувати, продавати або передавати ключі API без нашої попередньої згоди; або (7) надавати нам будь-яку особисту інформацію дітей віком до 13 років або відповідного віку цифрової згоди. Ви будете дотримуватися будь-яких обмежень ставок та інших вимог у нашій документації.',
    block7:
      '(d) Послуги третіх сторін. Будь-яке стороннє програмне забезпечення, послуги чи інші продукти, пов’язані з Послугою, регулюються власними умовами, і ми не несемо відповідальності за продукти третіх сторін.',
    block8:
      '(a) Ваш вміст. Ви можете надавати вхідні дані («Вхідні дані») до Служби та отримувати вихідні дані («Вихідні дані»), створені та повернуті на основі вхідних даних (разом іменуються «Вміст»). Між сторонами та в межах, дозволених чинним законодавством, ви володієте всіма Вхідними даними. Noam може використовувати Контент для надання та підтримки Сервісу, дотримання чинного законодавства та забезпечення виконання нашої політики. Ви несете відповідальність за Вміст, зокрема за те, щоб він не порушував жодних чинних законів або цих умов.',
    block9:
      '(b) Точність. Штучний інтелект і машинне навчання є галузями досліджень, що швидко розвиваються. Ми постійно прагнемо вдосконалювати наш сервіс, щоб зробити його більш точним, надійним, безпечним і корисним. Враховуючи ймовірнісний характер машинного навчання, використання нашого сервісу може призвести до неправильних результатів у деяких випадках, які можуть неточно відображати реальних людей, місця чи факти. Вам слід належним чином оцінити точність будь-якого виводу на основі вашого варіанту використання, зокрема шляхом перегляду виходів вручну.',
    subTitle1: 'Реєстрація та доступ',
    subTitle10: 'Подільність',
    subTitle2: 'Вимоги до використання',
    subTitle3: 'Зміст',
    subTitle4: 'Комісії та оплата',
    subTitle5: 'Конфіденційність, безпека та захист даних',
    subTitle6: 'Термін дії та розірвання',
    subTitle7: 'Відшкодування шкоди; Відмова від відповідальності; Обмеження відповідальності',
    subTitle8: 'Застосовне право та юрисдикція',
    subTitle9: 'Загальні умови',
    title: 'Умови обслуговування',
    updateTime: 'Оновлено: 15 березня 2024 р',
  },
  trialModal: {
    btn: 'Почніть зараз（лише 0,99 дол. США）',
    chat: 'ChatPDF',
    desc1: 'Після пробного періоду з вас стягуватиметься щорічна плата в розмірі 180 доларів США',
    desc2: 'Скасувати будь-коли',
    focus: 'Фокусування',
    hover: 'Переклад наведення',
    image: 'Переклад зображень',
    installBtn: 'Установіть зараз, щоб отримати подарунок',
    memo: 'Керування обраним',
    pdf: 'Паралельний переклад PDF',
    realtime: 'Миттєвий переклад',
    select: 'Переклад виділення слів',
    title: 'Вітальний подарунок',
    trialText: '7-денна пробна версія',
    video: 'Переклад відео',
    videoSummary: 'Відео резюме',
    web: 'Паралельний переклад',
    webSummary: 'Веб-резюме',
  },
  upgradeModal: {
    btn: 'Оновіть зараз',
    chat: { free: 'Ви досягли ліміту ChatPDF', pro: 'Ви досягли ліміту ChatPDF для цього місяця' },
    contactStr:
      'Зачекайте наступного скидання або зв’яжіться з нами за адресою contact@noam.tools.',
    limitAlertStr: 'Ви досягли ліміту безкоштовного плану. Оновіть, щоб продовжити.',
    more: 'Переглянути плани',
    pageLimit: { free: 'Ви досягли ліміту PDF-сторінок' },
    title: 'Нагадування',
    upgradeAlertStr: 'Ви досягли ліміту безкоштовного плану. Оновіть, щоб продовжити.',
    upload: {
      free: 'Ви досягли ліміту перекладу PDF',
      pro: 'Ви досягли ліміту перекладів PDF за цей місяць',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Приєднуйтесь зараз',
      label: 'Переваги для нового користувача:',
      remain: 'Залишилося лише 30',
      text: 'Доступно лише 100 місць! Візьміть свій зараз!',
    },
  },
}

export default TRANSLATION
